/*eslint-disable max-statements */
import React, { useEffect, useState } from "react";
import ErrorHandler from "../../shared/with-error-handler";
import PilotFaq from "../pilot-faq";
import PropTypes from "prop-types";
import NotFound from "../../shared/page-not-found";
import SellEasySteps from "../../../components/desktop/sell-easy-steps";
import { LazyComponent } from "../../../components/shared/lazy-image";
import loadable from "@loadable/component";
import styles from "./styles.css";
import HomeBanner from "../home-banner";
import Skeleton from "../home-banner/skeleton";
const WhyCars = loadable(() => import("../../../components/desktop/why-cars"));
const TestimonialCarouselRevamp = loadable(() => import("../../../components/desktop/testimonial-carousel-revamp"));

const AllianceOfferInfo = ({
    match,
    fetchAllianceDetailsConnect,
    updateLeadSourceConnect
}) => {

    const seoContent = "seo_content";
    const socialMedia = "socialMedia";
    const cmsPayload = {
        cmsuri: "sell-used-cars"
    };

    const [allianceDetails, setAllianceDetails] = useState({});
    const [faqs, setFaqs] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isFetched, setIsFetched] = useState(false);

    useEffect(() => {
        if (match.params.slug) {
            fetchAllianceDetailsConnect({
                slug: match.params.slug
            }).then((response) => {
                updateLeadSourceConnect(match.params.slug);
                setAllianceDetails(response.data.detail.allianceDetail);
                let parsedFaqs = [];
                if (response.data.detail.faq) {
                    parsedFaqs = response.data.detail.faq.map((item) => ({
                        ...item,
                        id: item.faq_id
                    }));
                }
                setIsFetched(true);
                setFaqs(parsedFaqs);
            })
                .catch(() => setIsError(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isError) {
        return <NotFound />;
    }

    return (
        <React.Fragment>
            {!isFetched ? <Skeleton /> :
                <HomeBanner
                    mainHeading={allianceDetails.heading}
                    subheading={allianceDetails.sub_heading}
                    isBrandsVisible={false}
                    isAllianceOffer={true}
                >
                    {isFetched && allianceDetails.alliance_partner_logo &&
                        <div styleName="styles.allianceLogoWrapper">
                            <label> Powered By </label>
                            <div styleName="styles.allianceLogo">
                                <img alt="alliance partner" src={allianceDetails.alliance_partner_logo} />
                            </div>
                        </div>
                    }
                </HomeBanner>
            }
            <div styleName={"styles.wrapper"}>
                <div styleName={"styles.easyStepWrap"}>
                    <LazyComponent>
                        <SellEasySteps />
                    </LazyComponent>
                </div>
                <div styleName={"styles.whychooseUs"}>
                    <LazyComponent>
                        <WhyCars
                            faqs={faqs}
                            setFaqs={setFaqs}
                            isSellerHomepage={true}
                            apiPayload={{ ...cmsPayload, expand: [seoContent, socialMedia] }}
                        />
                    </LazyComponent>
                </div>
                <ErrorHandler>
                    <div styleName={"styles.customCarousel"}>
                        <LazyComponent>
                            <TestimonialCarouselRevamp currentPage={"home"} showDate={false}/>
                        </LazyComponent>
                    </div>
                </ErrorHandler>
            </div>
            {
                faqs.length > 0 &&
                    <ErrorHandler>
                        <div styleName="styles.faqWrapper">
                            <LazyComponent>
                                <PilotFaq heading="Frequently Asked Questions"
                                    faqs={faqs} columns={1} />
                            </LazyComponent>
                        </div>
                    </ErrorHandler>
            }
        </React.Fragment>
    );
};
AllianceOfferInfo.propTypes = {
    match: PropTypes.object,
    fetchAllianceDetailsConnect: PropTypes.func,
    updateLeadSourceConnect: PropTypes.func
};
export default AllianceOfferInfo;
